<div class="genesys-tooltip-container" id="genesysTooltip" (click)="startChat()" *ngIf="showTooltip">
    <div class="genesys-tooltip">
        Click for<br>Customer Chat Support
    </div>
</div>